import React from 'react';
import { Row, RowChild } from 'styles';
import { Notification } from 'components/notification';

interface Props {
  notification: QueriedNotification;
  hideTopBorder: boolean;
  isSMB: boolean;
}

export const NotificationRow = ({
  notification,
  hideTopBorder,
  isSMB,
}: Props) => {
  const { utilityAccountDetails } = notification;
  const { accountNumber, displayServiceAddress, utilityDisplayName } =
    utilityAccountDetails || {};
  const shouldShowSubtitle: boolean =
    isSMB &&
    (!!accountNumber || !!displayServiceAddress || !!utilityDisplayName);

  return (
    <Row hideTopBorder={hideTopBorder}>
      <RowChild padding="32px 24px">
        <Notification
          notification={notification}
          buttonLinkProps={{
            backgroundless: true,
            color: 'primary',
          }}
          titleProps={{ color: 'secondary' }}
          messageProps={{ color: 'secondary', textStyle: 'paragraph400' }}
          shouldShowSubtitle={shouldShowSubtitle}
        />
      </RowChild>
    </Row>
  );
};
